var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcClear = function SvgIcClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D0D0D9",
    d: "M20.485 3.515A11.92 11.92 0 0 0 12 0a11.92 11.92 0 0 0-8.485 3.515A11.92 11.92 0 0 0 0 12c0 3.205 1.248 6.219 3.515 8.485A11.92 11.92 0 0 0 12 24c3.205 0 6.219-1.248 8.485-3.515A11.92 11.92 0 0 0 24 12c0-3.205-1.248-6.219-3.515-8.485"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9797A6",
    d: "M17.19 15.533a1.172 1.172 0 0 1-1.657 1.657L12 13.657 8.467 17.19a1.17 1.17 0 0 1-1.658 0 1.17 1.17 0 0 1 0-1.657L10.342 12 6.81 8.467A1.172 1.172 0 0 1 8.467 6.81L12 10.343l3.533-3.533a1.172 1.172 0 1 1 1.657 1.657L13.657 12z"
  })));
};
export default SvgIcClear;